export default __webpack_public_path__ + "static/media/logo.19cb877f.svg";